import { PayloadAction } from "@reduxjs/toolkit";
import { IActivityHistoryItem, IHistoryDataImporterRules, TSearchActivityHistoryItemPredicate } from "../../domain/model";
import { addItemsToCollection } from "./add-items-to-collection";

export function addActivityHistoryItemsReducer(
  state,
  action: PayloadAction<{
    id: string;
    items: IActivityHistoryItem[];
    componentFactory?: (item: IActivityHistoryItem) => HTMLElement;
    searchPredicate?: TSearchActivityHistoryItemPredicate;
    historyDataImporterRules?: IHistoryDataImporterRules;
  }>,
) {
  const { id, items, componentFactory, searchPredicate, historyDataImporterRules } = action.payload;
  return {
    ...state,
    collections: addItemsToCollection(state.collections, id, items, componentFactory, searchPredicate, historyDataImporterRules),
  };
}
